export class InsuranceOptionsRequestBuilder {
    constructor() {
        this.properties = {};
    }
    static validateRequest(request) {
        if (!request) {
            throw new Error("Missing insurance options request");
        }
        if (!request.id) {
            throw new Error("Missing vehicle ID for insurance options request");
        }
        if (!request.personalNumber) {
            throw new Error("Missing personal number for insurance options request");
        }
        if (!request.drivingDistance) {
            throw new Error("Missing driving distance for insurance options request");
        }
    }
    forVehicle(id) {
        this.properties.id = id;
        return this;
    }
    forDealer(id) {
        this.properties.branchId = id;
        return this;
    }
    forCustomer(personalNumber) {
        this.properties.personalNumber = personalNumber;
        return this;
    }
    withDrivingDistance(drivingDistance) {
        this.properties.drivingDistance = drivingDistance;
        return this;
    }
    build() {
        return this.properties;
    }
}
